import { i as o } from "./index-f8317a8e.js";
var r = o.process;
export {
  r as p
};
